import { render, staticRenderFns } from "./ModalFormItem.vue?vue&type=template&id=022a1731&scoped=true&"
import script from "./ModalFormItem.vue?vue&type=script&lang=js&"
export * from "./ModalFormItem.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormItem.vue?vue&type=style&index=0&id=022a1731&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a1731",
  null
  
)

export default component.exports